import { SVGInterface } from "../../interface";

const Tag = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12.8966 21.968C12.3655 21.9696 11.856 21.7586 11.4816 21.382L3.64757 13.547C3.23415 13.1348 3.02218 12.5621 3.06757 11.98L3.56757 5.41401C3.63886 4.4264 4.42576 3.64163 5.41357 3.57301L11.9796 3.07301C12.0306 3.06201 12.0826 3.06201 12.1336 3.06201C12.6634 3.06337 13.1713 3.27399 13.5466 3.64801L21.3816 11.482C21.7568 11.8571 21.9676 12.3659 21.9676 12.8965C21.9676 13.4271 21.7568 13.9359 21.3816 14.311L14.3106 21.382C13.9364 21.7583 13.4272 21.9693 12.8966 21.968ZM12.1326 5.06201L5.56157 5.56201L5.06157 12.133L12.8966 19.968L19.9666 12.898L12.1326 5.06201ZM8.65357 10.654C7.69941 10.6542 6.87798 9.98037 6.69165 9.04458C6.50531 8.10879 7.00597 7.17169 7.88744 6.80639C8.7689 6.44109 9.78566 6.74933 10.3159 7.54259C10.8461 8.33586 10.7422 9.39322 10.0676 10.068C9.6934 10.4443 9.18424 10.6553 8.65357 10.654Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Tag;
